import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Package, MapPin, HelpCircle, Menu, Wifi } from 'lucide-react';

const MobileBottomNav = ({ onMenuClick }) => {
  const location = useLocation();
  
  const navItems = [
    {
      label: 'Home',
      icon: Home,
      href: '/'
    },
    {
      label: 'Coverage',
      icon: MapPin,
      onClick: () => onMenuClick('coverage')
    },
    {
      label: 'Support',
      icon: HelpCircle,
      href: '/support'
    },
    {
      label: 'Menu',
      icon: Menu,
      onClick: () => onMenuClick('menu')
    }
  ];
  
  const isActive = (href) => {
    if (!href) return false;
    return location.pathname === href;
  };
  
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50">
      {/* Bottom Navigation Bar */}
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 border-t border-gray-800 shadow-lg shadow-black/30">
        <div className="flex justify-between items-center">
          {navItems.map((item, index) => {
            const isItemActive = item.href && isActive(item.href);
            
            const itemContent = (
              <>
                <div className={`relative ${isItemActive ? 'text-purple-400' : 'text-gray-400'}`}>
                  {/* Active indicator dot */}
                  {isItemActive && (
                    <span className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-purple-400 rounded-full"></span>
                  )}
                  <item.icon className={`w-5 h-5 mb-1 ${isItemActive ? 'text-purple-400' : 'text-gray-400'}`} />
                </div>
                <span className={`text-xs ${isItemActive ? 'text-purple-400' : 'text-gray-400'}`}>{item.label}</span>
              </>
            );
            
            return (
              <React.Fragment key={index}>
                {item.href ? (
                  <Link
                    to={item.href}
                    className={`flex flex-col items-center justify-center py-3 px-4 transition-colors ${
                      isItemActive
                        ? 'text-purple-400'
                        : 'text-gray-400 hover:text-purple-300'
                    }`}
                  >
                    {itemContent}
                  </Link>
                ) : (
                  <button
                    onClick={item.onClick}
                    className="flex flex-col items-center justify-center py-3 px-4 text-gray-400 hover:text-purple-300 transition-colors"
                  >
                    {itemContent}
                  </button>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
      
      {/* Bottom Safe Area (for iOS) */}
      <div className="h-safe-bottom bg-gray-900"></div>
    </div>
  );
};

export default MobileBottomNav;